import { useState } from "react"

export const useCategoryListHandling = ({setShowTable}) => {

    const [listData,setListData] = useState({
        categoryId: "",
        category: "",
        code: "",
        description: "",
        parentCategoryId: "",
        active: true,

        categoryStatus: "unchecked",
        codeStatus: "unchecked",
        parentCategoryIdStatus: "unchecked",
        descriptionStatus: "unchecked",

    });  

    const handleChange = (event,selectEvent) => {
        
        let listState ={...listData};

        if(event?.target === undefined && selectEvent){
            switch(selectEvent.name){
                
                case "category": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,50})$");
                    
                    if (alphaNLenghthRegex.test(event?.trim?.())) {
                    listState[selectEvent.name + "Status"] = "success";
                    setShowTable(true);
                    } else {
                    listState[selectEvent.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }

                    break;
                }

                 case "code": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,50})$");
                    
                    if (alphaNLenghthRegex.test(event?.trim?.())) {
                    listState[selectEvent.name + "Status"] = "success";
                    setShowTable(true);
                    } else {
                    listState[selectEvent.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }

                    break;
                }

                case "description": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,200})$");
                    
                    if (alphaNLenghthRegex.test(event?.trim?.())) {
                    listState[selectEvent.name + "Status"] = "success";
                    setShowTable(true);
                    } else {
                    listState[selectEvent.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }

                    break;
                }
                    
                default: {
                    
                    listState[selectEvent.name] = event;
                    listState[selectEvent.name + "Status"] = event ? "success" : "unchecked";
                    break;
                }
            }
            
            listState[selectEvent.name] = event;
        }
        setListData(listState);
    
    }


    return{
        listData,
        setListData,
        handleChange,
    }
}